import http from '../common/compornents/httpcommon';

class NonyusakiMaintenanceServ {

  getKenData = () => {
    return http.get('getKenData/');
  };

  getSiData = (params: any) => {
    return http.get('getSiData/', { params });
  };

  getNonyusakiMaintenanceData = (params: any) => {
    return http.get('getNonyusakiMaintenanceData/', { params });
  };

  getAddressData = (params: any) => {
    return http.get('getAddressData/', { params });
  };

  getKoukanNoData = (params: any) => {
    return http.get('getKoukanNoData/', { params });
  };

  insertNonyusakiMaintenanceData = (params: any) => {
    return http.get('insertNonyusakiMaintenanceData/', { params });
  };

  updateNonyusakiMaintenanceData = (params: any) => {
    return http.get('updateNonyusakiMaintenanceData/', { params });
  };

  deleteNonyusakiMaintenanceData = (params: any) => {
    return http.get('deleteNonyusakiMaintenanceData/', { params });
  };
}

export default new NonyusakiMaintenanceServ();
